import client from "../client"
import qs from "qs"

export const getMotibellDetail = async ({
  showDailyQuiz,
  showDailyUserQuiz,
  motibellNo,
  showCapacity,
}) => {
  const form = {
    show_daily_quiz: showDailyQuiz,
    show_daily_user_quiz: showDailyUserQuiz,
    show_capacity: showCapacity,
  }
  const queryString = qs.stringify(form)
  const response = await client.get(`/motibells/${motibellNo}?${queryString}`)

  return response.data
}
